// extracted by mini-css-extract-plugin
export default {"root":"Signup_root__ATX4S"};